import { useState } from "react";
import { toast } from "sonner";
import { Landmark, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { downloadBlob } from "@/lib/api";

export const LenderLetterButton = ({ path, name, testId = "lender-letter-button", className = "" }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await downloadBlob(path, `lender-summary-${(name || "study").normalize("NFKD").replace(/[^\w]+/g, "-").slice(0, 50)}.pdf`); toast.success("Lender letter downloaded"); }
    catch { toast.error("Could not create the lender letter"); } finally { setBusy(false); }
  };
  return (
    <Button data-testid={testId} variant="outline" disabled={busy} onClick={go} className={`rounded-full border-cyan-500/50 bg-transparent text-cyan-200 hover:bg-cyan-500/10 ${className}`}>
      {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Landmark className="h-4 w-4 mr-2" />}Lender letter
    </Button>
  );
};
